import { PlusOutlined } from '@ant-design/icons'
import { Divider, Form, Input, Select } from 'antd'
import React, { useRef, useState } from 'react'

export function DropdownSelect({
  editable,
  name,
  message,
  initialValue = '',
  tagRender,
  defaultValue,
  className,
  width,
  options = [],
  placeholder,
  required = false,
  mode = null,
  size = 'default',
  ...others
}) {
  if (!editable) return initialValue
  const { Option } = Select

  return (
    <div>
      <Form.Item key={name} name={name} rules={[{ required, message: { message } }]}>
        <Select
          className={className}
          size={size}
          placeholder={placeholder}
          mode={mode}
          defaultValue={defaultValue}
          tagRender={tagRender}
          style={{ width }}
          showSearch
          {...others}
        >
          {options.map((v, i) => (
            <Option key={i} value={v}>
              {v}
            </Option>
          ))}
        </Select>
      </Form.Item>
    </div>
  )
}

export function CustomSelect({
  name,
  message,
  initialValue,
  tagRender,
  className,
  width,
  editable,
  options = [],
  placeholder,
  required = false,
  mode = 'multiple',
  size = 'small',
}) {
  if (!editable) return initialValue
  const wrapperRef = useRef(null)
  const [itemToAdd, setItemToAdd] = useState()
  const [managedOptions, setManagedOptions] = useState([...options])
  const createNewItem = () => {
    const optionsCopy = [...managedOptions]
    setItemToAdd('')
    optionsCopy.push(itemToAdd)
    setManagedOptions(optionsCopy)
  }

  return (
    <div ref={wrapperRef}>
      <Form.Item key={name} name={name} rules={[{ required, message: { message } }]}>
        <Select
          getPopupContainer={(_) => wrapperRef?.current}
          className={className}
          size={size}
          placeholder={placeholder}
          mode={mode}
          tagRender={tagRender}
          style={{ width }}
          defaultValue={initialValue}
          dropdownRender={(menu) => (
            <div>
              {menu}
              <Divider style={{ margin: '4px 0' }} />
              <div style={{ display: 'flex', flexWrap: 'nowrap', padding: 8 }}>
                <Input
                  style={{ flex: 'auto' }}
                  value={itemToAdd}
                  onChange={(event) => setItemToAdd(event.target.value)}
                />
                <a
                  style={{
                    flex: 'none',
                    padding: '8px',
                    display: 'block',
                    cursor: 'pointer',
                  }}
                  onClick={createNewItem}
                >
                  <PlusOutlined /> Add Option
                </a>
              </div>
            </div>
          )}
        >
          {managedOptions.map((v) => (
            <Option key={v} value={v}>
              {v}
            </Option>
          ))}
        </Select>
      </Form.Item>
    </div>
  )
}
